module.exports = __webpack_public_path__ + "static/media/Header.a5bc7716.png";